(function () {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $28e72a95544a7e9f$exports = {};
$28e72a95544a7e9f$exports = JSON.parse("[{\"day\":\"mon\",\"amount\":17.45},{\"day\":\"tue\",\"amount\":34.91},{\"day\":\"wed\",\"amount\":52.36},{\"day\":\"thu\",\"amount\":31.07},{\"day\":\"fri\",\"amount\":23.39},{\"day\":\"sat\",\"amount\":43.28},{\"day\":\"sun\",\"amount\":25.48}]");


const $dddd44d7e246cbae$var$btnReload = /**@type {HTMLButtonElement} */ document.querySelector('button[class="btn-refresh"]');
const $dddd44d7e246cbae$var$failure = /**@type {HTMLDivElement} */ document.querySelector('div[class~="failure"]');
const $dddd44d7e246cbae$var$success = /**@type {HTMLDivElement} */ document.querySelector('div[class~="success"]');
const $dddd44d7e246cbae$var$balance = /**@type {HTMLParagraphElement}*/ document.querySelector('.expense-chart-component__balance');
const $dddd44d7e246cbae$var$amountPerDay = /**@type {NodeListOf<HTMLTableElement>} */ document.querySelectorAll('tr td');
const $dddd44d7e246cbae$var$daysOfWeek = /**@type {NodeListOf<HTMLTableElement>}*/ document.querySelectorAll('tr span[aria-hidden="true"]');
const $dddd44d7e246cbae$var$tableRows = /**@type {NodeListOf<HTMLTableRowElement>} */ document.querySelectorAll('tbody tr');
const $dddd44d7e246cbae$var$DELAY = /**@type{number} */ 1000;
const $dddd44d7e246cbae$var$SUNDAY = 0;
const $dddd44d7e246cbae$var$MONDAY = 1;
const $dddd44d7e246cbae$var$TUESDAY = 2;
const $dddd44d7e246cbae$var$WEDNESDAY = 3;
const $dddd44d7e246cbae$var$THURSDAY = 4;
const $dddd44d7e246cbae$var$FRIDAY = 5;
const $dddd44d7e246cbae$var$SATURDAY = 6;
const $dddd44d7e246cbae$var$FIRST_NODE_INDEX = $dddd44d7e246cbae$var$SUNDAY;
const $dddd44d7e246cbae$var$SECOND_NODE_INDEX = $dddd44d7e246cbae$var$MONDAY;
const $dddd44d7e246cbae$var$THIRD_NODE_INDEX = $dddd44d7e246cbae$var$TUESDAY;
const $dddd44d7e246cbae$var$FOURTH_NODE_INDEX = $dddd44d7e246cbae$var$WEDNESDAY;
const $dddd44d7e246cbae$var$FIFTH_NODE_INDEX = $dddd44d7e246cbae$var$THURSDAY;
const $dddd44d7e246cbae$var$SIXTH_NODE_INDEX = $dddd44d7e246cbae$var$FRIDAY;
const $dddd44d7e246cbae$var$SEVENTH_NODE_INDEX = $dddd44d7e246cbae$var$SATURDAY;
/**
 * A function that set the background-color of the table rows for the days of the week.
 * @param {number} index - The index of the table rows
 * @returns {void}
 */ function $dddd44d7e246cbae$var$setBackgroundColor(index) {
    $dddd44d7e246cbae$var$tableRows[index].addEventListener('mouseenter', function(evtObj) {
        if (evtObj.target instanceof HTMLTableRowElement) {
            const tableRow = evtObj.target;
            $dddd44d7e246cbae$var$createBackgroundColor(tableRow, '--cyan-hovered', 'hsla(186, 49%, 80%, 1)');
        }
    });
    $dddd44d7e246cbae$var$tableRows[index].addEventListener('mouseleave', function(evtObj) {
        if (evtObj.target instanceof HTMLTableRowElement) {
            const tableRow = evtObj.target;
            $dddd44d7e246cbae$var$createBackgroundColor(tableRow, '--cyan', 'hsl(186, 34%, 60%)');
        }
    });
    $dddd44d7e246cbae$var$createBackgroundColor($dddd44d7e246cbae$var$tableRows[index], '--cyan', 'hsl(186, 34%, 60%)');
}
/**
 * This function creates the background color for the chart for the corresponding day
 * @param {HTMLTableRowElement} bar -- The event object
 * @param {string} cssVariable -- The CSS variable property
 * @param {string} colorCode -- The color code
 * @returns {void}
 */ function $dddd44d7e246cbae$var$createBackgroundColor(bar, cssVariable, colorCode) {
    bar?.style.setProperty(cssVariable, colorCode);
    bar.style.backgroundColor = `var(${cssVariable})`;
}
/**
 * This function will increase the height of each bar chart
 */ function $dddd44d7e246cbae$var$animateBarChart() {
    $dddd44d7e246cbae$var$tableRows.forEach(function(tableRow, index) {
        tableRow.classList.add('day');
        $dddd44d7e246cbae$var$amountPerDay[index].classList.remove('hide');
    });
}
/**
 * This function will render the days and amounts information on the UI
 */ function $dddd44d7e246cbae$var$renderDaysAndAmounts() {
    try {
        if (!Array.isArray((0, (/*@__PURE__*/$parcel$interopDefault($28e72a95544a7e9f$exports))))) throw new Error('Oops! You are lost');
        const dataValues = (0, (/*@__PURE__*/$parcel$interopDefault($28e72a95544a7e9f$exports)));
        dataValues.forEach(function(dataValue, index) {
            $dddd44d7e246cbae$var$amountPerDay[index].textContent = `$${dataValue.amount}`;
            $dddd44d7e246cbae$var$daysOfWeek[index].textContent = dataValue.day;
        });
        $dddd44d7e246cbae$var$failure?.classList.add('hide');
        $dddd44d7e246cbae$var$success?.classList.remove('hide');
        $dddd44d7e246cbae$var$balance?.classList.remove('failure');
        setTimeout($dddd44d7e246cbae$var$animateBarChart, $dddd44d7e246cbae$var$DELAY);
        // We need to know what the current date us nd compare with the days of the week from the chart, then we apply a different color for the corresponding individual bar chart.
        const currentDate = new Date();
        const currentDay = currentDate.getDay();
        // Using a switch case we want to evaluate the expression above and match the value of that expression to a series of case clauses.
        switch(currentDay){
            case $dddd44d7e246cbae$var$SUNDAY:
                $dddd44d7e246cbae$var$setBackgroundColor($dddd44d7e246cbae$var$SEVENTH_NODE_INDEX);
                break;
            case $dddd44d7e246cbae$var$MONDAY:
                $dddd44d7e246cbae$var$setBackgroundColor($dddd44d7e246cbae$var$FIRST_NODE_INDEX);
                break;
            case $dddd44d7e246cbae$var$TUESDAY:
                $dddd44d7e246cbae$var$setBackgroundColor($dddd44d7e246cbae$var$SECOND_NODE_INDEX);
                break;
            case $dddd44d7e246cbae$var$WEDNESDAY:
                $dddd44d7e246cbae$var$setBackgroundColor($dddd44d7e246cbae$var$THIRD_NODE_INDEX);
                break;
            case $dddd44d7e246cbae$var$THURSDAY:
                $dddd44d7e246cbae$var$setBackgroundColor($dddd44d7e246cbae$var$FOURTH_NODE_INDEX);
                break;
            case $dddd44d7e246cbae$var$FRIDAY:
                $dddd44d7e246cbae$var$setBackgroundColor($dddd44d7e246cbae$var$FIFTH_NODE_INDEX);
                break;
            case $dddd44d7e246cbae$var$SATURDAY:
                $dddd44d7e246cbae$var$setBackgroundColor($dddd44d7e246cbae$var$SIXTH_NODE_INDEX);
                break;
            default:
                $dddd44d7e246cbae$var$tableRows.forEach(function(tableRow) {
                    tableRow.style.setProperty('--soft-red', 'hsl(10, 79%, 65%)');
                    tableRow.style.backgroundColor = 'var(--soft-red)';
                });
        }
    } catch (error) {
        const [strongText, normalText] = error.message.split('!');
        const failureMessage = /**@type {HTMLParagraphElement} */ document.querySelector('.failure__message');
        const strongFailureMessage = /**@type {HTMLElement} */ document.querySelector('.failure__message strong');
        strongFailureMessage.textContent = `${strongText}!`;
        if (!failureMessage.innerHTML.includes(normalText.trim())) {
            const normal = document.createTextNode(normalText.trim());
            failureMessage.appendChild(normal);
        }
        $dddd44d7e246cbae$var$failure?.classList.remove('hide');
        $dddd44d7e246cbae$var$success?.classList.add('hide');
        $dddd44d7e246cbae$var$balance?.classList.add('failure');
        $dddd44d7e246cbae$var$btnReload.addEventListener('click', function() {
            $dddd44d7e246cbae$var$renderDaysAndAmounts();
        });
    }
}
$dddd44d7e246cbae$var$renderDaysAndAmounts();

})();
//# sourceMappingURL=index.54f54e25.js.map
